import {
  GET_ALL_TEMPLATES,
  ADD_TEMPLATE,
  GET_TEMPLATE,
  UPDATE_TEMPLATE,
  GET_USER_ALL_TEMPLATE,
  RENAME_TEMPLATE,
  ASSIGN_TEMPLATE,
  DELETE_TEMPLATE,
  EDIT_USER_TEMPLATE,
  GET_USER_TEMPLATE,
  GET_ALL_USERS,
  NESTED_USER_REPORTS,
  ASSIGNED_TO_ME_REPORTS,
  REPORTS_ASSIGNED_BY_USER,
  MYTEAM_REPORTS,
  USER_REPORT,
  ADD_QUESTION_COMMENT,
  ACCEPT_REPORT,
  ADD_REPORT_COMMENT,
  DRAFT_REPORT,
  SUBMIT_REPORT,
  GET_USER_REPORTS,
  GET_RECURRENCE_TYPES,
  GENERATE_REPORT,
} from "lib/constants";
import { deleteAPICall, getAPICall, postAPICall, putAPICall } from "../lib/callApi";

export const fetchMyTeamReports = async (payload) => getAPICall(MYTEAM_REPORTS, true, payload);
export const fetchReportsAssignedByUser = async (payload) =>
  getAPICall(REPORTS_ASSIGNED_BY_USER, true, payload);

export const fetchAssignedToMeReports = async (payload) =>
  getAPICall(ASSIGNED_TO_ME_REPORTS, true, payload);

export const fetchNestedUserReports = async (payload) =>
  getAPICall(NESTED_USER_REPORTS, true, payload);

export const fetchTemplateList = async (payload) => {
  const data = await getAPICall(GET_ALL_TEMPLATES, true, payload);
  return data;
};

export const templateAdd = async (payload) => {
  const data = await postAPICall(ADD_TEMPLATE, true, payload);
  return data;
};

export const getTemplateById = async (id, params) => {
  const data = await getAPICall(GET_TEMPLATE + id, true, params);
  return data;
};

export const updateTemplate = async (payload, id) => {
  const data = await postAPICall(UPDATE_TEMPLATE + id, true, payload);
  return data;
};

export const fetchUserAllTemplate = async (id) => {
  const data = await getAPICall(GET_USER_ALL_TEMPLATE + id, true);
  return data;
};

export const renameTemplate = async (id, payload) => {
  const data = await putAPICall(RENAME_TEMPLATE + id, true, payload);
  return data;
};

export const assignTemplate = async (id, payload) => {
  const data = await postAPICall(ASSIGN_TEMPLATE + id, true, payload);
  return data;
};

export const deleteTemplate = async (id) => {
  const data = await deleteAPICall(DELETE_TEMPLATE + id, true);
  return data;
};

export const updateUserSpecificTemplate = async (payload, id) => {
  const data = await postAPICall(EDIT_USER_TEMPLATE + id, true, payload);
  return data;
};

export const fetchUserSpecificTemplate = async (id, payload) => {
  const data = await postAPICall(GET_USER_TEMPLATE + id, true, payload);
  return data;
};

export const fetchUsers = async () => {
  const data = await getAPICall(GET_ALL_USERS, true);
  return data;
};

export const fetchReportDetail = async (payload) => getAPICall(USER_REPORT, true, payload);

export const addQuestionComment = async (payload) => {
  const data = await postAPICall(ADD_QUESTION_COMMENT, true, payload);
  return data;
};

export const addReportComment = async (payload) => {
  const data = await postAPICall(ADD_REPORT_COMMENT, true, payload);
  return data;
};

export const acceptReport = async (payload) => {
  const data = await postAPICall(ACCEPT_REPORT, true, payload);
  return data;
};

export const draftReport = async (payload) => {
  const data = await postAPICall(DRAFT_REPORT, true, payload);
  return data;
};

export const submitReport = async (payload) => {
  const data = await postAPICall(SUBMIT_REPORT, true, payload);
  return data;
};

export const fetchUserReportsTo = async () => {
  const data = await getAPICall(GET_USER_REPORTS, true);
  return data;
};

export const fetchRecurrenceTypes = async () => {
  const data = await getAPICall(GET_RECURRENCE_TYPES, true);
  return data;
};

export const generateReportApiCall = async (payload) => {
  const data = await postAPICall(GENERATE_REPORT, true, payload);
  return data;
};
